import useSetExport from '@components/export/useSetExport';
import { useMemo } from 'react';

// related events table widget
function useSetAIAlertAllEventsExport({ columns, alerts, alert }) {
  useSetExport({
    pageKey: 'trends',
    sectionKey: 'alerts-panel',
    widgetKey: 'ai-alert-all-events',
    widgetInfo: alert ? { title: `Alerts with root cause: ${alert.rootCauseDisplay}` } : {},
    data: alerts,
    headers: columns,
  });
}

export default useSetAIAlertAllEventsExport;
